"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_rum_1 = require("@datadog/browser-rum");
const utils_1 = require("./utils");
class DatadogMonitor {
    constructor(appId, clientToken, service, site = 'datadoghq.eu', env = 'dev', version = '1.0.0', 
    // optional param to extend or rewrite datadog rum application init configs
    datadogRumAppOptions, maskSensitiveData = true) {
        const message = (name) => `${name} is not specified`;
        if (!appId) {
            throw Error(message('Application id'));
        }
        if (!clientToken) {
            throw Error(message('Client token'));
        }
        if (!service) {
            throw Error(message('Service name'));
        }
        this._canSendEvent = true;
        this._maskSensitiveData = maskSensitiveData;
        this.initDatadogRum(appId, clientToken, service, site, env, version, datadogRumAppOptions);
    }
    sendError(error, context) {
        browser_rum_1.datadogRum.addError(error, context);
    }
    setUser(userId, userEmail) {
        browser_rum_1.datadogRum.setUser({
            id: userId,
            email: (0, utils_1.redactEmailAddress)(userEmail, this._maskSensitiveData)
        });
    }
    initDatadogRum(applicationId, clientToken, service, site, env, version, datadogRumAppOptions) {
        const initRumConfiguration = {
            applicationId,
            clientToken,
            site,
            service,
            env,
            version
        };
        browser_rum_1.datadogRum.init({
            ...datadogRumAppOptions,
            ...initRumConfiguration,
            beforeSend: () => {
                return this._canSendEvent;
            }
        });
    }
}
exports.default = DatadogMonitor;
//# sourceMappingURL=DatadogMonitor.js.map